import React from 'react';
import ClubsIcon from '../../../common/icons/clubsIcon';
import { MY_CLUBS_ROUTE } from '../../../../constants/Routes';

export const clubsGroup = [
  {
    route: MY_CLUBS_ROUTE,
    icon: <ClubsIcon size="30px" />,
    title: 'Clubes Ripley',
    id: 'myClubsSection',
  },
];
